<template lang="pug">
  .task-fakeback(v-if="ishow" v-platform-expose="handleExpose")
    .task-left
      .left
        .icon-new-block
          SafeImg(class-name="left-logo" :src="item.taskImgUrl")
      .mid
        .title {{ item.guideDesc }}
        .progress
          img.progress-weekend-icon(v-if="item.recommendContent && item.recommendContent.taskMaketkIcon" :src="item.recommendContent.taskMaketkIcon")
          .progress-right(v-if="item.recommendContent && item.recommendContent.taskMaketkText")
            img.progress-right-img(:src="coinIcon")
            .progress-right-text {{ item.recommendContent.taskMaketkText }}
          .progress-left(@click="handleClick") {{ item.btnName || "返币订单" }}
    TaskGrid(:channel-list="item.gridItems" v-if="item.gridItems && item.gridItems.length")
</template>

<script>
import SafeImg from '@/components/safe-img';
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import { ParamsUtil } from '@/utils/params';
import { isArray } from 'lodash';
import TaskGrid from './task-grid.vue';
import { isFackBackTask } from '../../common/helper';
import { getRebateModuleKey } from '../../common/task';
import SPM from '../../common/spm';

export default {
  name: 'TaskFakeback',
  components: {
    SafeImg,
    TaskGrid,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    // 在任务列表里的排序次序
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      coinIcon: 'https://m.hellobike.com/fd018348_new_coin.png',
    };
  },
  computed: {
    ishow() {
      const { item } = this;
      return item
      && isFackBackTask(item.marketPlan)
      && isArray(item.gridItems)
      && item.gridItems.length > 0;
    },
    // 点击跳转链接（与 handleClick 中保持一致）
    clkUrl() {
      const { btnLink } = this.item || {};
      if (btnLink && btnLink.app) {
        return btnLink.app;
      }
      return `https://m.hellobike.com/AppCommercialH5/${config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html#/myorder?scene=rebateBonus`;
    },
  },
  methods: {
    handleClick() {
      jumpUrl(this.clkUrl);
      SPM.clickButton({
        buttonName: 'Welfare_purchase_task',
        businessInfo: {
          desc: this.item?.guideDesc || '',
          taskname: this.item?.taskName || '',
          taskid: this.item?.taskCode || '',
          takeoutTestVersion: getRebateModuleKey(),
          adsource: ParamsUtil.getParam('adsource') || '',
          rankNum: this.index + 1,
          clk_url: this.clkUrl,
          buyicon_name: this.item?.btnName || '',
          buyicon_picture: this.item?.taskImgUrl || '',
        },
      });
    },
    handleExpose() {
      SPM.moduleExpose({
        moduleId: 'Welfare_purchase_task',
        contentId: 'Welfare_purchase_task',
        exposureTimes: 1,
        businessInfo: {
          desc: this.item?.guideDesc || '',
          taskname: this.item?.taskName || '',
          taskid: this.item?.taskCode || '',
          adsource: ParamsUtil.getParam('adsource') || '',
          takeoutTestVersion: getRebateModuleKey(),
          rankNum: this.index + 1,
          buyicon_picture: this.item?.taskImgUrl || '',
          buyicon_name: this.item?.btnName || '',
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.task-fakeback {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  position: relative;
  padding: 0.12rem;

  .task-left {
    display: flex;
    width: 100%;

    .left {
      margin-right: 0.1rem;

      .icon-new-block {
        overflow: hidden;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.12rem;
      }
    }
  }

  .mid {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    align-items: flex-start;

    .title {
      font-size: 0.14rem;
      line-height: 0.2rem;
      font-weight: 500;
      color: #242729;
      margin-bottom: 0.02rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .progress {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;

      .progress-weekend-icon {
        height: 0.18rem;
        margin-right: 0.05rem;
      }

      .progress-left {
        flex: 1;
        min-width: 0;
        color: #879099;
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: center;

        &::after {
          content: "";
          display: inline-block;
          width: 0.12rem;
          height: 0.12rem;
          background-image: url("https://m.hellobike.com/15e7879a35.png");
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }

      .progress-right {
        display: flex;
        align-items: center;
        height: 0.16rem;
        padding-right: 0.16rem;
        border-radius: 0.16rem;
      }

      .progress-right-img {
        width: 0.16rem;
        height: 0.16rem;
      }

      .progress-right-text {
        color: #fe852a;
        font-weight: 600;
        font-size: 0.12rem;
        margin-left: 0.02rem;
      }
    }
  }
}
</style>
